// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selected[data-v-172abad2]{font-weight:700}li[data-v-172abad2]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
